import React, { useEffect, useState } from "react";
import CircleSpinnerLoader from "../../Reusable/LoaderComponent/CircleSpinnerLoader";
import { IClickLogBody, useClickLogAPI } from "@/app/hooks/api_hooks/org/useClickLogAPI";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useUtils } from "@/app/hooks/useUtils";

interface NudgeCardProps {
  source?: string;
  nudge: any;
  onClose?: () => void;
  isWidth?: boolean;
  colorCode?: any;
  loader: boolean;
  handelOnNudgeAction?: (e: any) => void;
  setSelectedItems?: (e: any) => void;
  selectedItems?: any;
  customer_id?: string;
}

const NudgeCardComponent: React.FC<NudgeCardProps> = (props) => {
  const [isChecked, setIsChecked] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [cta2Disable, setCta2Disable] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(null);
  const nudge = props?.nudge;

  const userLogInfo = useAppSelector((state) => state.auth?.user?.email);
  const { execute: logAPI } = useClickLogAPI();
  const { veticDateFormat } = useUtils();

  useEffect(() => {
    if (nudge?.check_box_text) {
      setButtonDisable(true);
    }
  }, [nudge]);

  const handleCheckboxChange = (item: string) => {
    props?.setSelectedItems(
      (prevSelected) =>
        prevSelected.includes(item)
          ? prevSelected.filter((i) => i !== item) // remove
          : [...prevSelected, item], // add
    );
  };

  const handelClose = (act: string) => {
    const logBody: IClickLogBody = {
      event_type: act === "NUDGE_CHECKBOX_CLICKED" ? "NUDGE_CHECKBOX_CLICKED" : "NUDGE_CLICKED_2",
      client_id: props?.customer_id,
      pet_id: nudge?.heading_variables?.pet_id,
      vms_user_id: userLogInfo,
      scr_id: nudge?.journey_point?.toLowerCase(),
      timestamp: Date.now(),
      nudge_type: nudge?.alert_category_list?.length > 0 && nudge?.alert_category_list[0],
      nudge_name: nudge?.name,
      checkbox_text: nudge?.check_box_text ? nudge?.check_box_text : undefined,
    };
    logAPI(logBody);
  };

  function formatMembershipName(name) {
    if (typeof name !== "string") {
      return "";
    }

    return name && name?.replace(/_/g, " ").trim();
  }
  useEffect(() => {
    // Existing CTA1 logic: disable when grooming/food require selection but none selected
    if (
      (nudge?.description_variables?.grooming_membership_list?.length > 0 ||
        nudge?.description_variables?.food_items?.length > 0) &&
      props.selectedItems?.length === 0
    ) {
      setButtonDisable(true);
    } else {
      setButtonDisable(false);
    }
  }, [nudge, props.selectedItems]);

  useEffect(() => {
    // CTA2 disable only for teleconsultation CM case when no items selected
    if (nudge?.teleconsultation_nudge && nudge?.description_variables?.booking_list_cm?.length > 0) {
      setCta2Disable(!(props.selectedItems && props.selectedItems.length > 0));
    } else {
      setCta2Disable(false);
    }
  }, [nudge, props.selectedItems]);

  const handelVisitDraftEMR = () => {
    const usePet = nudge?.description_variables;
    window.open(`/app/customer/profile/customer-details/EMR/${usePet?.customer_id}/${usePet?.pet_id}`, "_blank");
  };

  const isActionButtonShow =
    nudge?.alert_category_list?.includes("Dr Reminder") ||
    nudge?.alert_category_list?.includes("hr_follow_up_check_emr");


  const isShowEmrID =
    nudge?.alert_category_list?.includes("Draft Check") ||
    nudge?.alert_category_list?.includes("High Risk Cart");

  const isVaccinationNudge = nudge?.alert_category_list?.includes("Vaccination Addon");

  if (nudge && isVaccinationNudge) {
    return (
      <div className="w-[392px] m-auto transform transition-all duration-500 ease-out">
        <div
          className="flex flex-col items-start justify-center gap-5 p-[29px_30px] rounded-[10px] border-[1.5px] border-[#BF7D01] bg-[#FFF] shadow-[1px_2px_4px_0_rgba(0,0,0,0.15),_0_0_5px_0_rgba(0,0,0,0.05)] overflow-hidden"
        >
          {nudge?.image && (
            <div className="flex w-[332px] h-[144px] p-[22px_115.998px_22px_116px] justify-center items-center rounded-[14px] bg-[#F4F4F4]">
              <img src={nudge?.image} alt={nudge?.heading} className="h-full object-contain" />
            </div>
          )}
          <h3 className="text-[18px] font-semibold text-black font-geist leading-normal">
            {nudge?.heading || "Vaccine requested by Pet Parent"}
          </h3>
          <div className="w-full flex flex-col gap-3">
            {[
              ...(nudge?.description_variables?.vaccination_addons || []),
              ...(nudge?.description_variables?.reminder_addons || []),].map((item: any, id: number) => {
              const name = item?.vaccine_name;
              const status = item?.status;
              const date = veticDateFormat(item?.due_date);
              const isOverdue = status?.toLowerCase() === "overdue";
              const isDone = status?.toLowerCase() === "done";
              const isMissing = status?.toLowerCase() === "missing data";
              const statusLabel = isDone ? "Up to Date" : isMissing ? "Missing Data" : status;
              const statusColor = isOverdue ? "text-[#EF0303]" : isDone ? "text-[#149463]" : isMissing ? "text-[#FF5B5B]" : "text-[#FA8F34]";
              const dotColor = isOverdue ? "bg-[#EF0303]" : isDone ? "bg-[#149463]" : isMissing ? "bg-[#FF5B5B]" : "bg-[#FA8F34]";
              return (
                <div key={id} className="flex flex-col items-start gap-2 w-[332px] p-[8px_12px] rounded-[12px] border border-[#E2E8F0] bg-[#F8FAFC]">
                  <div className="text-[14px] font-medium text-[#0F172A] font-geist leading-normal">
                    {name}
                  </div>
                  {status &&
                  <div className="flex items-center gap-2 font-geist">
                    <span className={`w-2 h-2 rounded-full ${dotColor}`} />
                    <span className={`text-[12px] font-normal leading-normal ${statusColor}`}>{statusLabel}</span>
                    <span className="text-[12px] font-normal text-[#64748B] leading-normal">•</span>
                    <span className="text-[12px] font-normal text-[#64748B] leading-normal">{date}</span>
                  </div>
                    }
                </div>
              );
            })}
          </div>
          {nudge?.cta_1 && (
            <button
              disabled={buttonDisable}
              onClick={() => {
                props.handelOnNudgeAction("CTA1");
                setButtonClicked("CTA1");
              }}
              className="flex w-[335px] p-[10px] justify-center items-center gap-[10px] rounded-[8px] transition-all duration-200 transform hover:scale-[1.02] text-[16px] font-medium leading-normal text-white self-center border border-[#15B478] bg-[#00915A] shadow-[inset_0_2px_8px_0_#39CE95]"
            >
              {props?.loader && buttonClicked === "CTA1" ? (
                <CircleSpinnerLoader h="20" w="83" />
              ) : (
                nudge?.cta_1
              )}
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    nudge && (
      <div
        className={`
        transform transition-all duration-500 ease-out m-auto
       ${props?.source === "PWL" ? "w-full 2xl:w-full" : "sm:w-[500px]"} ${props?.source !== "PWL" && !isActionButtonShow && "2xl:w-[590px]"} 
       
      `}
      >
        <div
          className="relative overflow-hidden rounded-[12px] backdrop-blur-sm shadow-md"
          style={{
            backgroundColor: props?.colorCode?.bg_color,
            border: `1.5px solid ${props?.colorCode?.border_color}`,
          }}
        >
          <div className="p-4 2xl:p-5">
            {/* Header with icon and close button */}
            <div className="flex items-start justify-between ">
              <div className="flex items-start space-x-4">
                {/* Icon with background */}
                <div className="w-[100px] h-[100px] 2xl:w-[120px] 2xl:h-[120px]">
                  <img src={nudge?.image} alt={nudge?.heading} className=" w-full h-full object-cover" />
                </div>

                {/* Title and message */}
                <div className="flex-1 min-w-0  ">
                  <h3 className="font-semibold pb-1 text-black text-sm pt-1 2xl:pt-2 2xl:text-[18px] 2xl:mb-1 font-geist [font-feature-settings:'liga_off,_clig_off'] flex items-center gap-2 ">
                    {nudge?.heading_icon && (
                      <span>
                        <img src={nudge?.heading_icon} alt="nudge_icon" className="w-6 h-6" />
                      </span>
                    )}
                    {nudge?.heading}
                  </h3>
                  {nudge?.description && (
                    <p className="text-[#444B59] font-normal text-sm 2xl:text-base leading-relaxed font-geist">
                      {nudge?.description}
                    </p>
                  )}
                  {isShowEmrID && (
                    <p
                      className="my-3 text-blue-500 text-sm font-medium underline cursor-pointer "
                      onClick={() => handelVisitDraftEMR()}
                    >
                      Go to {nudge?.description_variables?.pet_name_1}'s EMR
                    </p>
                  )}
                  {nudge?.description_variables?.vaccines?.length > 0 && (
                    <ul className="list-disc list-outside pl-5 text-[#444B59] text-sm pt-1 2xl:text-base leading-relaxed">
                      {nudge?.description_variables?.vaccines?.map((item, id) => {
                        return (
                          <li className="font-geist text-[#444B59]" key={id}>
                            {item}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                  {nudge?.description_variables?.doctor_list?.length > 0 && (
                    <ul className="list-disc list-outside pl-5 text-[#444B59] text-sm pt-1 2xl:text-base leading-relaxed">
                      {nudge?.description_variables?.doctor_list?.map((item, id) => {
                        return (
                          <li className="font-geist text-[#444B59]" key={id}>
                            {item}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                  {nudge?.description_variables?.grooming_membership_list?.length > 0 && (
                    <ul className="list-disc list-outside pl-2 text-[#444B59] text-sm pt-1 2xl:text-base leading-relaxed">
                      {nudge.description_variables.grooming_membership_list.map((item, id) => {
                        const label = item && typeof item === "object" ? Object.values(item)[0] : item;
                        const isChecked = props?.selectedItems.includes(item);
                        return (
                          <div className="font-geist text-[#444B59] mt-3" key={id}>
                            <div className="flex items-center me-4 ">
                              <input
                                id={`checkbox-${id}`}
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => handleCheckboxChange(item)}
                                className={`w-4 h-4 text-black bg-gray-100 rounded-[4px] border ${isChecked ? "border-green-600" : "border-[#000000]"
                                  } dark:focus:ring-green-600`}
                              />
                              <label
                                htmlFor={`checkbox-${id}`}
                                className="ms-2 text-xs font-medium italic text-[#444B59] font-geist cursor-pointer"
                              >
                                {formatMembershipName(label)}
                              </label>
                            </div>
                          </div>
                        );
                      })}
                    </ul>
                  )}
                  {nudge?.description_variables?.food_items?.length > 0 && (
                    <ul className="list-disc list-outside pl-2 text-[#444B59] text-sm pt-1 2xl:text-base leading-relaxed">
                      {nudge.description_variables.food_items.map((item, id) => {
                        const label = item && typeof item === "object" ? Object.values(item)[0] : item;
                        const isChecked = props?.selectedItems.includes(item);
                        return (
                          <div className="font-geist text-[#444B59] mt-3" key={id}>
                            <div className="flex items-center me-4 ">
                              <input
                                id={`checkbox-${id}`}
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => handleCheckboxChange(item)}
                                className={`w-4 h-4 text-black bg-gray-100 rounded-[4px] border ${isChecked ? "border-green-600" : "border-[#000000]"
                                  } dark:focus:ring-green-600`}
                              />
                              <label
                                htmlFor={`checkbox-${id}`}
                                className="ms-2 text-xs font-medium italic text-[#444B59] font-geist cursor-pointer"
                              >
                                {label}
                              </label>
                            </div>
                          </div>
                        );
                      })}
                    </ul>
                  )}

                  {/* Teleconsultation Nudge in CM case */}
                  {nudge?.description_variables?.booking_list_cm?.length > 0 && (
                    <ul className="list-disc list-outside pl-2 text-[#444B59] text-sm pt-1 2xl:text-base leading-relaxed">
                      {nudge?.description_variables?.booking_list_cm?.map((item, id) => {
                        const label =
                          item && typeof item === "object"
                            ? `${item?.pet_name}'s Teleconsultation with ${item?.doctor_name} at ${item?.time}`
                            : item;
                        const isChecked = props?.selectedItems?.includes(item);

                        return (
                          <div className="font-geist text-[#444B59] mt-3" key={id}>
                            <div className="flex items-center me-4">
                              <input
                                id={`checkbox-${id}`}
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => handleCheckboxChange(item)}
                                className={`w-4 h-4 text-black bg-gray-100 rounded-[4px] border ${isChecked ? "border-green-600" : "border-[#000000]"
                                  } dark:focus:ring-green-600`}
                              />
                              <label
                                htmlFor={`checkbox-${id}`}
                                className="ms-2 text-xs font-medium italic text-[#444B59] font-geist cursor-pointer"
                              >
                                {formatMembershipName(label)}
                              </label>
                            </div>
                          </div>
                        );
                      })}
                    </ul>
                  )}

                  {/* Teleconsultation Nudge in doctor case */}
                  {nudge?.description_variables?.booking_list_doctor?.length > 0 && (
                    <ul className="list-disc list-outside pl-5 text-[#444B59] text-sm pt-1 2xl:text-base leading-relaxed">
                      {nudge?.description_variables?.booking_list_doctor?.map((item, id) => {
                        const label =
                          item && typeof item === "object"
                            ? `Pet Parent: ${item?.user_name}, Pet: ${item?.pet_name}, Time:  ${item?.time} of Appt`
                            : item;
                        return (
                          <li className="font-geist text-[#444B59]" key={id}>
                            {label}
                          </li>
                        );
                      })}
                    </ul>
                  )}

                  {/* Invocing error for cat case nudge list*/}
                  {nudge?.description_variables?.invoicing_membership_name?.length > 0 && (
                    <ul className="list-disc list-outside pl-5 text-[#444B59] text-sm pt-1 2xl:text-base leading-relaxed">
                      {nudge?.description_variables?.invoicing_membership_name?.map((item, id) => {
                        return (
                          <li className="font-geist text-[#444B59]" key={id}>
                            {item}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </div>
              </div>

              {nudge?.close_cta && (
                <button
                  onClick={() => {
                    handelClose("NUDGE_CLOSED");
                  }}
                  className="
                 rounded-full transition-all duration-200
                
                text-gray-400 
                flex-shrink-0 ml-2
              "
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M18 6L6 18M6 6L18 18"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              )}
            </div>

            {/* Checkbox for additional options (like in the reference) */}

            {/* Action buttons */}

            <div className={`flex items-center  ${nudge?.check_box_text ? "justify-between" : "justify-end"} pt-4 `}>
              {nudge?.check_box_text && (
                <div
                  className={`flex items-center me-4 rounded-md px-2 py-1 transition-colors duration-150 ${
                    isChecked ? "bg-black" : "bg-transparent"
                  }`}
                >
                  <input
                    id="green-checkbox"
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => {
                      setIsChecked(!isChecked);
                      setButtonDisable(!buttonDisable);
                      handelClose("NUDGE_CHECKBOX_CLICKED");
                    }}
                    className={`w-4 h-4 bg-gray-100 rounded-md border ${
                      isChecked ? "border-black accent-black" : "border-[#000000] accent-black"
                    } dark:focus:ring-green-600`}
                  />
                  <label
                    htmlFor="green-checkbox"
                    className={`ms-2 text-xs font-medium italic font-geist cursor-pointer ${
                      isChecked ? "text-white" : "text-[#000000]"
                    }`}
                  >
                    {nudge?.check_box_text}
                  </label>
                </div>
              )}
              {!isActionButtonShow &&
                <div className="flex items-center justify-end space-x-3">
                  {nudge?.cta_2 && (
                    <button
                      disabled={cta2Disable}
                      onClick={() => {
                        props.handelOnNudgeAction("CTA2");
                        setButtonClicked("CTA2");
                      }}
                      className={`
                    py-2 flex rounded-lg items-center justify-center font-medium text-sm font-geist
                    transition-all duration-200 transform hover:scale-105
                    ${cta2Disable || props?.loader ? "bg-[#e2e2e2] text-black border-gray-50 cursor-not-allowed" : "bg-[#FFFFFF] text-[#000000] border border-[#E2E2E2]"} px-4 "
                    
                  `}
                    >
                      {props?.loader && buttonClicked === "CTA2" ? <CircleSpinnerLoader h="20" w="87" /> : nudge?.cta_2}
                    </button>
                  )}
                  {nudge?.cta_1 && (
                    <button
                      disabled={buttonDisable}
                      onClick={() => {
                        props.handelOnNudgeAction("CTA1");
                        setButtonClicked("CTA1");
                      }}
                      className={`
                    py-2 flex rounded-lg items-center justify-center font-medium text-sm font-geist
                    transition-all duration-200 transform hover:scale-105
                   ${buttonDisable || props?.loader ? "bg-[#e2e2e2] text-black border-gray-50 cursor-not-allowed" : "bg-[#00915A] text-white  border-[#15B478]  shadow-[inset_0px_2px_8px_0px_#39CE95]"}   px-10 "
                  `}
                    >
                      {props?.loader && buttonClicked === "CTA1" ? <CircleSpinnerLoader h="20" w="83" /> : nudge?.cta_1}
                    </button>
                  )}
                </div>}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default NudgeCardComponent;
